import React from 'react'
import { Outlet } from 'react-router-dom'
import Menu from './components/Menu/Menu'
import FooterMain from './components/Footer/FooterMain'

const PublicLayout: React.FC = () => {
    return (
        <div className="h-full flex flex-col">
            <Menu />
            <main className="flex flex-1 flex-col">
                <Outlet />
            </main>
            <div>
                <FooterMain />
            </div>
        </div>
    )
}

export default PublicLayout
